export const rssTranslations = {
  fr: {
    title: "Agrégateur RSS Médical",
    titleMobile: "RSS Médical",
    subtitle: "Restez informé des dernières actualités médicales",
    loading: "Chargement...",
    tabs: {
      notifications: "Notifications",
      notificationsMobile: "Notifs",
      feeds: "Flux RSS",
      feedsMobile: "Flux",
      subscriptions: "Abonnements",
      subscriptionsMobile: "Abos"
    },
    notifications: {
      title: "Dernières actualités",
      subtitle: "Vos notifications RSS personnalisées",
      empty: "Aucune notification pour le moment",
      emptySubtitle: "Abonnez-vous à des flux RSS pour recevoir des actualités",
      new: "Nouveau",
      readArticle: "Lire l'article"
    },
    feeds: {
      title: "Flux RSS disponibles",
      subtitle: "Découvrez et abonnez-vous aux flux RSS médicaux",
      search: "Rechercher un flux RSS...",
      specialty: "Spécialité",
      custom: "Personnalisé",
      subscribed: "Abonné",
      subscribe: "S'abonner",
      unsubscribe: "Se désabonner"
    },
    subscriptions: {
      title: "Mes abonnements",
      subtitle: "Gérez vos abonnements et préférences de notification",
      empty: "Aucun abonnement actuel",
      emptySubtitle: "Abonnez-vous à des flux dans l'onglet 'Flux RSS'",
      frequency: "Fréquence",
      daily: "Quotidien",
      weekly: "Hebdomadaire",
      monthly: "Mensuel"
    },
    process: {
      button: "Traiter avec IA",
      processing: "Traitement des flux RSS en cours...",
      success: "Flux RSS traités avec succès"
    },
    success: {
      subscribed: "Abonnement réussi",
      unsubscribed: "Désabonnement réussi",
      frequencyUpdated: "Fréquence mise à jour",
      customFeedAdded: "Flux personnalisé ajouté"
    },
    errors: {
      loadData: "Erreur lors du chargement des données",
      subscriptionError: "Erreur lors de l'abonnement",
      updateFrequency: "Erreur lors de la mise à jour de la fréquence",
      processError: "Erreur lors du traitement des flux",
      addCustomFeed: "Erreur lors de l'ajout du flux personnalisé"
    },
    customFeed: {
      addButton: "Ajouter un flux personnalisé",
      dialogTitle: "Ajouter un flux RSS personnalisé",
      dialogDesc: "Ajoutez votre propre flux RSS pour recevoir des notifications personnalisées.",
      feedName: "Nom du flux *",
      feedNamePlaceholder: "ex: Journal de Cardiologie",
      feedUrl: "URL du flux RSS *",
      feedUrlPlaceholder: "https://exemple.com/feed.xml",
      specialty: "Spécialité *",
      specialtyPlaceholder: "Sélectionnez une spécialité",
      description: "Description",
      descPlaceholder: "Description courte du contenu de ce flux...",
      tags: "Tags",
      tagPlaceholder: "Ajouter un tag...",
      cancel: "Annuler",
      validating: "Validation...",
      add: "Ajouter",
      requiredFields: "Veuillez remplir tous les champs obligatoires",
      invalidUrl: "URL invalide",
      invalidUrlDesc: "L'URL ne semble pas être un flux RSS valide",
      feedAdded: "Flux ajouté",
      feedAddedDesc: "Le flux RSS personnalisé a été ajouté avec succès",
      addError: "Impossible d'ajouter le flux RSS"
    }
  },
  en: {
    title: "Medical RSS Aggregator",
    titleMobile: "Medical RSS",
    subtitle: "Stay informed with the latest medical news",
    loading: "Loading...",
    tabs: {
      notifications: "Notifications",
      notificationsMobile: "Notifs",
      feeds: "RSS Feeds",
      feedsMobile: "Feeds",
      subscriptions: "Subscriptions",
      subscriptionsMobile: "Subs"
    },
    notifications: {
      title: "Latest news",
      subtitle: "Your personalized RSS notifications",
      empty: "No notifications at the moment",
      emptySubtitle: "Subscribe to RSS feeds to receive news",
      new: "New",
      readArticle: "Read article"
    },
    feeds: {
      title: "Available RSS feeds",
      subtitle: "Discover and subscribe to medical RSS feeds",
      search: "Search RSS feed...",
      specialty: "Specialty",
      custom: "Custom",
      subscribed: "Subscribed",
      subscribe: "Subscribe",
      unsubscribe: "Unsubscribe"
    },
    subscriptions: {
      title: "My subscriptions",
      subtitle: "Manage your subscriptions and notification preferences",
      empty: "No current subscriptions",
      emptySubtitle: "Subscribe to feeds in the 'RSS Feeds' tab",
      frequency: "Frequency",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly"
    },
    process: {
      button: "Process with AI",
      processing: "Processing RSS feeds...",
      success: "RSS feeds processed successfully"
    },
    success: {
      subscribed: "Successfully subscribed",
      unsubscribed: "Successfully unsubscribed",
      frequencyUpdated: "Frequency updated",
      customFeedAdded: "Custom feed added"
    },
    errors: {
      loadData: "Error loading data",
      subscriptionError: "Subscription error",
      updateFrequency: "Error updating frequency",
      processError: "Error processing feeds",
      addCustomFeed: "Error adding custom feed"
    },
    customFeed: {
      addButton: "Add custom feed",
      dialogTitle: "Add custom RSS feed",
      dialogDesc: "Add your own RSS feed to receive personalized notifications.",
      feedName: "Feed name *",
      feedNamePlaceholder: "e.g. Cardiology Journal",
      feedUrl: "RSS feed URL *",
      feedUrlPlaceholder: "https://example.com/feed.xml",
      specialty: "Specialty *",
      specialtyPlaceholder: "Select a specialty",
      description: "Description",
      descPlaceholder: "Brief description of feed content...",
      tags: "Tags",
      tagPlaceholder: "Add a tag...",
      cancel: "Cancel",
      validating: "Validating...",
      add: "Add",
      requiredFields: "Please fill in all required fields",
      invalidUrl: "Invalid URL",
      invalidUrlDesc: "The URL does not appear to be a valid RSS feed",
      feedAdded: "Feed added",
      feedAddedDesc: "Custom RSS feed added successfully",
      addError: "Unable to add RSS feed"
    }
  },
  es: {
    title: "Agregador RSS Médico",
    titleMobile: "RSS Médico",
    subtitle: "Manténgase informado con las últimas noticias médicas",
    loading: "Cargando...",
    tabs: {
      notifications: "Notificaciones",
      notificationsMobile: "Notifs",
      feeds: "Feeds RSS",
      feedsMobile: "Feeds",
      subscriptions: "Suscripciones",
      subscriptionsMobile: "Subs"
    },
    notifications: {
      title: "Últimas noticias",
      subtitle: "Sus notificaciones RSS personalizadas",
      empty: "No hay notificaciones por el momento",
      emptySubtitle: "Suscríbase a feeds RSS para recibir noticias",
      new: "Nuevo",
      readArticle: "Leer artículo"
    },
    feeds: {
      title: "Feeds RSS disponibles",
      subtitle: "Descubra y suscríbase a feeds RSS médicos",
      search: "Buscar feed RSS...",
      specialty: "Especialidad",
      custom: "Personalizado",
      subscribed: "Suscrito",
      subscribe: "Suscribirse",
      unsubscribe: "Desuscribirse"
    },
    subscriptions: {
      title: "Mis suscripciones",
      subtitle: "Gestione sus suscripciones y preferencias de notificación",
      empty: "No hay suscripciones actuales",
      emptySubtitle: "Suscríbase a feeds en la pestaña 'Feeds RSS'",
      frequency: "Frecuencia",
      daily: "Diario",
      weekly: "Semanal",
      monthly: "Mensual"
    },
    process: {
      button: "Procesar con IA",
      processing: "Procesando feeds RSS...",
      success: "Feeds RSS procesados exitosamente"
    },
    success: {
      subscribed: "Suscripción exitosa",
      unsubscribed: "Desuscripción exitosa",
      frequencyUpdated: "Frecuencia actualizada",
      customFeedAdded: "Feed personalizado agregado"
    },
    errors: {
      loadData: "Error al cargar datos",
      subscriptionError: "Error de suscripción",
      updateFrequency: "Error al actualizar frecuencia",
      processError: "Error al procesar feeds",
      addCustomFeed: "Error al agregar feed personalizado"
    },
    customFeed: {
      addButton: "Agregar feed personalizado",
      dialogTitle: "Agregar feed RSS personalizado",
      dialogDesc: "Agregue su propio feed RSS para recibir notificaciones personalizadas.",
      feedName: "Nombre del feed *",
      feedNamePlaceholder: "ej: Revista de Cardiología",
      feedUrl: "URL del feed RSS *",
      feedUrlPlaceholder: "https://ejemplo.com/feed.xml",
      specialty: "Especialidad *",
      specialtyPlaceholder: "Seleccione una especialidad",
      description: "Descripción",
      descPlaceholder: "Breve descripción del contenido del feed...",
      tags: "Tags",
      tagPlaceholder: "Agregar un tag...",
      cancel: "Cancelar",
      validating: "Validando...",
      add: "Agregar",
      requiredFields: "Por favor complete todos los campos obligatorios",
      invalidUrl: "URL inválida",
      invalidUrlDesc: "La URL no parece ser un feed RSS válido",
      feedAdded: "Feed agregado",
      feedAddedDesc: "El feed RSS personalizado fue agregado con éxito",
      addError: "No se pudo agregar el feed RSS"
    }
  }
};